import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import * as XLSX from 'xlsx';

import {
  CommonFlex,
  FilterLabel,
  HeaderContainer,
  InputWithLabelSection,
  PageTitle,
} from "../../styledComponents/common";
import { FilterContainer } from "../../styledComponents/tasks";
import ReactDateRangePicker from "components/ReactDateRangePicker/ReactDateRangePicker";
import Select from "../../components/ReactSelectDropdown";
import { SearchWithButtonContainer } from "components/Search/searchStyles";
import MembersFilter from "../Members/MembersFilter";
import SelfEvaluationFilter from "./SelfEvaluationFilter";
import { Container } from "styledComponents/createProject";
import CircularProgress from "./CircularProgress";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import excelIcon from "../../assets/img/icons/excel-green.svg";
import {
  CardsContainer,
  Card,
  CardLeftContent,
  CardRightContent,
  CardText,
  CardHeader,
  ColoredCardCircle,
  CardStat,
  CardStatsContainer,
  StatItem,
  StatLabel,
  StatValue,
} from "./SelfEvaluationStyles";
import { ButtonIcon, WhiteButtonWithIcon } from "styledComponents/buttons";
import ButtonTextLoader from "components/Loaders/ButtonTextLoader";

const SelfEvaluation = (
  {
    officesShortList,
    getOfficesShortList,
    getMembersList,
    membersList,
    // pagination
    totalMembersCount,
    pageSize,
    selfEvaluationListIsLoading,
    getSelfEvaluationList,
    evaluationCards,
    memberShortListIsLoading,
    memberShortList,
    getOrganizationMembersList,
  }) => {
    const { t } = useTranslation();
    const [memberList, setMemberList] = useState([]);
    const [tabSelect, setTabSelect] = useState('active');
    const [selectedOffice, setSelectedOffice] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');

    const [selectedMember, setSelectedMember] = useState(null);
    const [memberOptions, setMemberOptions] = useState([]);
    const [saveErrors, setSaveErrors] = useState({});


    const [userCodeSearchTerm, setUserCodeSearchTerm] = useState('');
    const [currentUserCodeSearchedTerm, setCurrentUserCodeSearchedTerm] =
      useState('');

      const [selectedRole, setSelectedRole] = useState({
        label: t('all_roles'),
        value: null,
      });

      // pagination
      const [currentPageNumber, setCurrentPageNumber] = useState(1);


      const [selfEvaluationParams, setSelfEvaluationParams] = useState({
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        office_id: null,
        mashaer_dates: null
      });

      useEffect(() => {
        getOfficesShortList();
      }, []);

      // Once we have the offices list, select the first office and call the API
      useEffect(() => {
        if (officesShortList && officesShortList.length > 0 && !selectedOffice) {
          // Select the first office from the list
          const firstOffice = {
            label: officesShortList[0].name,
            value: officesShortList[0].id
          };
          setSelectedOffice(firstOffice);

          // Update params with the first office ID
          setSelfEvaluationParams(prev => ({
            ...prev,
            office_id: firstOffice.value,
          }));
        }
      }, [officesShortList]);

      // Call the API whenever selfEvaluationParams changes
      useEffect(() => {
        console.log('selfEvaluationParams', selfEvaluationParams);
        if (selfEvaluationParams.office_id) {
          console.log('Calling API with params:', selfEvaluationParams);
          getSelfEvaluationList(selfEvaluationParams);
        }
      }, [selfEvaluationParams, getSelfEvaluationList]);


      // if office is changed, update the office id
      useEffect(() => {
        if (selectedOffice && selectedOffice.value) {
          console.log('Selected office changed to:', selectedOffice.label, selectedOffice.value);
          setSelfEvaluationParams(prevParams => ({
            ...prevParams,
            office_id: selectedOffice.value,
          }));
        }

        if (selectedMember && selectedMember.value) {
          console.log('Selected member changed to:', selectedMember.label, selectedMember.value);
          setSelfEvaluationParams(prevParams => ({
            ...prevParams,
            employee_id: selectedMember.value,
          }));
        }

        if (selectedRole && selectedRole.value) {
          console.log('Selected role changed to:', selectedRole.label, selectedRole.value);
          setSelfEvaluationParams(prevParams => ({
            ...prevParams,
            employee_role: selectedRole.value,
          }));
        }

        // if office is changed, update the member list
        if (selectedOffice && selectedOffice.value) {
          getOrganizationMembersList({
            office_id: selectedOffice.value,
          });
        }

      }, [selectedOffice, selectedMember, selectedRole]);



    useEffect(() => {
      if (membersList && membersList.length > 0) {
        setMemberList(membersList);
      } else if (membersList && membersList.length === 0) {
        setMemberList([]);
      }
    }, [membersList]);

    const handleSearchByName = () => {
      const payload = {
        page: 1,
      };
      if (searchTerm && searchTerm.trim()) {
        payload.name = searchTerm.toLowerCase().trim();
        setCurrentSearchedTerm(searchTerm);
      } else {
        setCurrentSearchedTerm('');
      }
      if (selectedOffice && selectedOffice.value) {
        payload.office_id = selectedOffice.value;
      }
      if (selectedRole && selectedRole.value) {
        payload.role = selectedRole.value;
      }
      if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
        payload.user_code = userCodeSearchTerm.toLowerCase().trim();
      }
      // getMembersList(payload);

      setCurrentPageNumber(1);
    };
    const handleClearSearch = () => {
      if (currentSearchedTerm) {
        const payload = {
          page: 1,
        };
        if (selectedOffice && selectedOffice.value) {
          payload.office_id = selectedOffice.value;
        }
        if (selectedRole && selectedRole.value) {
          payload.role = selectedRole.value;
        }
        if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
          payload.user_code = userCodeSearchTerm.toLowerCase().trim();
        }
        // getMembersList(payload);

        setCurrentPageNumber(1);
      }
      setTimeout(() => {
        setSearchTerm('');
        setCurrentSearchedTerm('');
      }, 100);
    };

    const handleSearchByUserCode = () => {
      const payload = {
        page: 1,
      };
      if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
        payload.user_code = userCodeSearchTerm.toLowerCase().trim();
        setCurrentUserCodeSearchedTerm(userCodeSearchTerm);
      } else {
        setCurrentUserCodeSearchedTerm('');
      }
      if (selectedOffice && selectedOffice.value) {
        payload.office_id = selectedOffice.value;
      }
      if (selectedRole && selectedRole.value) {
        payload.role = selectedRole.value;
      }
      if (searchTerm && searchTerm.trim()) {
        payload.name = searchTerm.toLowerCase().trim();
      }
      // getMembersList(payload);

      setCurrentPageNumber(1);
    };
    const handleClearUserCodeSearch = () => {
      if (currentUserCodeSearchedTerm) {
        const payload = {
          page: 1,
        };
        if (selectedOffice && selectedOffice.value) {
          payload.office_id = selectedOffice.value;
        }
        if (selectedRole && selectedRole.value) {
          payload.role = selectedRole.value;
        }
        if (searchTerm && searchTerm.trim()) {
          payload.name = searchTerm.toLowerCase().trim();
        }
        // getMembersList(payload);

        setCurrentPageNumber(1);
      }
      setTimeout(() => {
        setUserCodeSearchTerm('');
        setCurrentUserCodeSearchedTerm('');
      }, 100);
    };



    const selectOffice = e => {
      console.log('Office selection changed to:', e?.label, e?.value);

      const payload = {
        page: 1,
      };
      if (e && e.value) {
        payload.office_id = e.value;
      }
      if (selectedRole && selectedRole.value) {
        payload.role = selectedRole.value;
      }
      // getMembersList(payload);
      setCurrentPageNumber(1);
      setSearchTerm('');
      setCurrentSearchedTerm('');
      setUserCodeSearchTerm('');
      setCurrentUserCodeSearchedTerm('');

      setSelectedOffice(e);
    };

    const handleRoleChange = e => {
      if (!e || e.value === null) {
        setSelfEvaluationParams(prevParams => ({
          ...prevParams,
          employee_role: null,
        }));
      }

      setSelectedRole(e);
    };

    const onSearchTermChange = e => {
      const { value } = e.target;
      setSearchTerm(value);
    };

    const onUserCodeSearchTermChange = e => {
      const { value } = e.target;
      setUserCodeSearchTerm(value);
    };

    const ringColors = ["#7986CB", "#4DB6AC", "#9CCC65", "#FF7043", "#FFB74D"];

    // Helper function to get percentage from kpiScores
    const getPercentageFromKpiScores = (kpiScores, key) => {
      if (!kpiScores || !kpiScores[key]) return 0;

      if (key === 'mashaer_presence') {
        return kpiScores[key].details?.days_present * 20 || 0;
      }
      return kpiScores[key].details?.percentage || 0;
    };

    // Render content based on loading state and data availability
    const renderContent = () => {
      if (selfEvaluationListIsLoading) {
        // Return loading state
        return (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">{t("loading")}</span>
            </div>
          </div>
        );
      } else if (!evaluationCards || evaluationCards.length === 0) {
        // Return no data state
        return (
          <NoDataComponent
            title={t("no_evaluation_data_found")}
            subtitle={t("no_evaluation_data_available_for_selected_office")}
          />
        );
      } else {
        // Return evaluation cards
        return (
          <CardsContainer>
            {evaluationCards.map((card, index) => (
              <Card key={card.id}>
                <CardLeftContent>
                  <CardHeader>
                    <CardText> {t("name")} : {card.memberInfo.name}</CardText>
                    <CardText> {t("role")} : {card.memberInfo.role}</CardText>
                    <CardText> {t("office")} : {card.memberInfo.office}</CardText>
                  </CardHeader>
                  <CardStatsContainer>
                    {Object.keys(card.kpi_scores || {}).filter(key => key !== 'total_score').map((key, index) => {
                      const percentage = getPercentageFromKpiScores(card.kpi_scores, key);

                      return (
                        <CardStat key={key}>
                          <ColoredCardCircle color={ringColors[index % ringColors.length]} />
                          <StatItem>
                            <StatLabel>{t(key)}:</StatLabel>
                            <StatValue>{percentage.toFixed(1)}%</StatValue>
                          </StatItem>
                        </CardStat>
                      );
                    })}
                    <CardStat>
                      <ColoredCardCircle color="#fff" />
                      <StatItem>
                        <StatLabel>
                          <span style={{ fontWeight: 'bold' }}>{t("total_score")}:</span>
                        </StatLabel>
                        <StatValue>{card.kpi_scores.total_score.toFixed(1)}%</StatValue>
                      </StatItem>
                    </CardStat>
                  </CardStatsContainer>
                </CardLeftContent>
                <CardRightContent>
                  <CircularProgress kpiScores={card.kpi_scores} />
                </CardRightContent>
              </Card>
            ))}
          </CardsContainer>
        );
      }
    };


    const onMemberNameChange = e => {
      if (!e) {
        // remove employee id from the payload
        setSelfEvaluationParams(prevParams => ({
          ...prevParams,
          employee_id: null,
        }));
      }
      setSelectedMember(e);
    };

    useEffect(() => {
      if (memberShortList && memberShortList.length > 0) {
        const options = memberShortList.map(member => ({
          label: member.name,
          value: member.id,
        }));
        setMemberOptions(options);
      }
    }, [memberShortList]);

    // Handle date range changes
    const handleDateRangeChange = (dateRange) => {
      if (dateRange && dateRange.startDate && dateRange.endDate) {
        setSelfEvaluationParams(prevParams => ({
          ...prevParams,
          start_date: dateRange.startDate.format('YYYY-MM-DD'),
          end_date: dateRange.endDate.format('YYYY-MM-DD'),
        }));
      }
    };

    const handleExportToExcel = () => {
      if (!evaluationCards || evaluationCards.length === 0) {
        return;
      }

      // Transform the data for Excel
      const excelData = evaluationCards.map(card => {
        const row = {
          'Name': card.memberInfo.name,
          'Role': card.memberInfo.role,
          'Office': card.memberInfo.office,
          'Total Score': `${card.kpi_scores.total_score.toFixed(1)}%`
        };

        // Add individual KPI scores
        Object.keys(card.kpi_scores || {}).forEach(key => {
          if (key !== 'total_score') {
            const percentage = getPercentageFromKpiScores(card.kpi_scores, key);
            row[t(key)] = `${percentage.toFixed(1)}%`;
          }
        });

        return row;
      });

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Self Evaluation Report");

      // Generate Excel file
      const fileName = `Self_Evaluation_Report_${moment().format('YYYY-MM-DD')}.xlsx`;
      XLSX.writeFile(wb, fileName);
    };

    return (
      <div className="content">
        <CommonFlex justifyContent="space-between">
          <PageTitle>{t("self_evaluation")}</PageTitle>
        {localStorage.getItem('user_role') === 'admin' &&
          selectedOffice &&
          selectedOffice.value ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={selfEvaluationListIsLoading ? '0 45px' : '0 25px'}
            >
              {selfEvaluationListIsLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex>
        <HeaderContainer columns="1fr auto">
          <SelfEvaluationFilter
            officesShortList={officesShortList}
            getOfficesShortList={getOfficesShortList}
            selectedOffice={selectedOffice}
            selectOffice={selectOffice}
            searchTerm={searchTerm}
            onSearchTermChange={onSearchTermChange}
            handleSearchByName={handleSearchByName}
            handleClearSearch={handleClearSearch}
            userCodeSearchTerm={userCodeSearchTerm}
            onUserCodeSearchTermChange={onUserCodeSearchTermChange}
            handleSearchByUserCode={handleSearchByUserCode}
            handleClearUserCodeSearch={handleClearUserCodeSearch}
            selectedRole={selectedRole}
            onRoleChange={handleRoleChange}
            isMemberNameLoading={memberShortListIsLoading}
            memberOptions={memberOptions}
            selectedMember={selectedMember}
            onMemberNameChange={onMemberNameChange}
            saveErrors={saveErrors}
            onDateRangeChange={handleDateRangeChange}
          />
        </HeaderContainer>
        {/* Cards layout with circular progress charts or no data message */}
        <Container>
          {renderContent()}
        </Container>
        {/* Pagination will go here */}
      </div>
    );
};

export default SelfEvaluation;



// import { useState, useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import moment from "moment";

// import {
//   CommonFlex,
//   FilterLabel,
//   HeaderContainer,
//   InputWithLabelSection,
//   PageTitle,
// } from "../../styledComponents/common";
// import { FilterContainer } from "../../styledComponents/tasks";
// import ReactDateRangePicker from "components/ReactDateRangePicker/ReactDateRangePicker";
// import Select from "../../components/ReactSelectDropdown";
// import { SearchWithButtonContainer } from "components/Search/searchStyles";
// import MembersFilter from "../Members/MembersFilter";
// import SelfEvaluationFilter from "./SelfEvaluationFilter";
// import { Container } from "styledComponents/createProject";
// import CircularProgress from "./CircularProgress";
// import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
// import {
//   CardsContainer,
//   Card,
//   CardLeftContent,
//   CardRightContent,
//   CardText,
//   CardHeader,
//   ColoredCardCircle,
//   CardStat,
//   CardStatsContainer,
//   StatItem,
//   StatLabel,
//   StatValue,
// } from "./SelfEvaluationStyles";

// const SelfEvaluation = (
//   {
//     officesShortList,
//     getOfficesShortList,
//     getMembersList,
//     membersList,
//     // pagination
//     totalMembersCount,
//     pageSize,
//     selfEvaluationListIsLoading,
//     getSelfEvaluationList,
//     evaluationCards,
//     memberShortListIsLoading,
//     memberShortList,
//     getOrganizationMembersList,
//   }) => {
//     const { t } = useTranslation();
//     const [memberList, setMemberList] = useState([]);
//     const [tabSelect, setTabSelect] = useState('active');
//     const [selectedOffice, setSelectedOffice] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');

//     const [selectedMember, setSelectedMember] = useState(null);
//     const [memberOptions, setMemberOptions] = useState([]);
//     const [saveErrors, setSaveErrors] = useState({});


//     const [userCodeSearchTerm, setUserCodeSearchTerm] = useState('');
//     const [currentUserCodeSearchedTerm, setCurrentUserCodeSearchedTerm] =
//       useState('');

//       const [selectedRole, setSelectedRole] = useState({
//         label: t('all_roles'),
//         value: null,
//       });

//       // pagination
//       const [currentPageNumber, setCurrentPageNumber] = useState(1);


//       const [selfEvaluationParams, setSelfEvaluationParams] = useState({
//         start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
//         end_date: moment().format('YYYY-MM-DD'),
//         office_id: null,
//         mashaer_dates: null
//       });

//       useEffect(() => {
//         getOfficesShortList();
//       }, []);

//       // Once we have the offices list, select the first office and call the API
//       useEffect(() => {
//         if (officesShortList && officesShortList.length > 0 && !selectedOffice) {
//           // Select the first office from the list
//           const firstOffice = {
//             label: officesShortList[0].name,
//             value: officesShortList[0].id
//           };
//           setSelectedOffice(firstOffice);

//           // Update params with the first office ID
//           setSelfEvaluationParams(prev => ({
//             ...prev,
//             office_id: firstOffice.value,
//           }));
//         }
//       }, [officesShortList]);

//       // Call the API whenever selfEvaluationParams changes
//       useEffect(() => {
//         console.log('selfEvaluationParams', selfEvaluationParams);
//         if (selfEvaluationParams.office_id) {
//           console.log('Calling API with params:', selfEvaluationParams);
//           getSelfEvaluationList(selfEvaluationParams);
//         }
//       }, [selfEvaluationParams, getSelfEvaluationList]);


//       // if office is changed, update the office id
//       useEffect(() => {
//         if (selectedOffice && selectedOffice.value) {
//           console.log('Selected office changed to:', selectedOffice.label, selectedOffice.value);
//           setSelfEvaluationParams(prevParams => ({
//             ...prevParams,
//             office_id: selectedOffice.value,
//           }));
//         }

//         if (selectedMember && selectedMember.value) {
//           console.log('Selected member changed to:', selectedMember.label, selectedMember.value);
//           setSelfEvaluationParams(prevParams => ({
//             ...prevParams,
//             employee_id: selectedMember.value,
//           }));
//         }

//         if (selectedRole && selectedRole.value) {
//           console.log('Selected role changed to:', selectedRole.label, selectedRole.value);
//           setSelfEvaluationParams(prevParams => ({
//             ...prevParams,
//             employee_role: selectedRole.value,
//           }));
//         }

//         // if office is changed, update the member list
//         if (selectedOffice && selectedOffice.value) {
//           getOrganizationMembersList({
//             office_id: selectedOffice.value,
//           });
//         }

//       }, [selectedOffice, selectedMember, selectedRole]);



//     useEffect(() => {
//       if (membersList && membersList.length > 0) {
//         setMemberList(membersList);
//       } else if (membersList && membersList.length === 0) {
//         setMemberList([]);
//       }
//     }, [membersList]);

//     const handleSearchByName = () => {
//       const payload = {
//         page: 1,
//       };
//       if (searchTerm && searchTerm.trim()) {
//         payload.name = searchTerm.toLowerCase().trim();
//         setCurrentSearchedTerm(searchTerm);
//       } else {
//         setCurrentSearchedTerm('');
//       }
//       if (selectedOffice && selectedOffice.value) {
//         payload.office_id = selectedOffice.value;
//       }
//       if (selectedRole && selectedRole.value) {
//         payload.role = selectedRole.value;
//       }
//       if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
//         payload.user_code = userCodeSearchTerm.toLowerCase().trim();
//       }
//       // getMembersList(payload);

//       setCurrentPageNumber(1);
//     };
//     const handleClearSearch = () => {
//       if (currentSearchedTerm) {
//         const payload = {
//           page: 1,
//         };
//         if (selectedOffice && selectedOffice.value) {
//           payload.office_id = selectedOffice.value;
//         }
//         if (selectedRole && selectedRole.value) {
//           payload.role = selectedRole.value;
//         }
//         if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
//           payload.user_code = userCodeSearchTerm.toLowerCase().trim();
//         }
//         // getMembersList(payload);

//         setCurrentPageNumber(1);
//       }
//       setTimeout(() => {
//         setSearchTerm('');
//         setCurrentSearchedTerm('');
//       }, 100);
//     };

//     const handleSearchByUserCode = () => {
//       const payload = {
//         page: 1,
//       };
//       if (userCodeSearchTerm && userCodeSearchTerm.trim()) {
//         payload.user_code = userCodeSearchTerm.toLowerCase().trim();
//         setCurrentUserCodeSearchedTerm(userCodeSearchTerm);
//       } else {
//         setCurrentUserCodeSearchedTerm('');
//       }
//       if (selectedOffice && selectedOffice.value) {
//         payload.office_id = selectedOffice.value;
//       }
//       if (selectedRole && selectedRole.value) {
//         payload.role = selectedRole.value;
//       }
//       if (searchTerm && searchTerm.trim()) {
//         payload.name = searchTerm.toLowerCase().trim();
//       }
//       // getMembersList(payload);

//       setCurrentPageNumber(1);
//     };
//     const handleClearUserCodeSearch = () => {
//       if (currentUserCodeSearchedTerm) {
//         const payload = {
//           page: 1,
//         };
//         if (selectedOffice && selectedOffice.value) {
//           payload.office_id = selectedOffice.value;
//         }
//         if (selectedRole && selectedRole.value) {
//           payload.role = selectedRole.value;
//         }
//         if (searchTerm && searchTerm.trim()) {
//           payload.name = searchTerm.toLowerCase().trim();
//         }
//         // getMembersList(payload);

//         setCurrentPageNumber(1);
//       }
//       setTimeout(() => {
//         setUserCodeSearchTerm('');
//         setCurrentUserCodeSearchedTerm('');
//       }, 100);
//     };



//     const selectOffice = e => {
//       console.log('Office selection changed to:', e?.label, e?.value);

//       const payload = {
//         page: 1,
//       };
//       if (e && e.value) {
//         payload.office_id = e.value;
//       }
//       if (selectedRole && selectedRole.value) {
//         payload.role = selectedRole.value;
//       }
//       // getMembersList(payload);
//       setCurrentPageNumber(1);
//       setSearchTerm('');
//       setCurrentSearchedTerm('');
//       setUserCodeSearchTerm('');
//       setCurrentUserCodeSearchedTerm('');

//       setSelectedOffice(e);
//     };

//     const handleRoleChange = e => {
//       if (!e || e.value === null) {
//         setSelfEvaluationParams(prevParams => ({
//           ...prevParams,
//           employee_role: null,
//         }));
//       }

//       setSelectedRole(e);
//     };

//     const onSearchTermChange = e => {
//       const { value } = e.target;
//       setSearchTerm(value);
//     };

//     const onUserCodeSearchTermChange = e => {
//       const { value } = e.target;
//       setUserCodeSearchTerm(value);
//     };

//     const ringColors = ["#7986CB", "#4DB6AC", "#9CCC65", "#FF7043", "#FFB74D"];

//     // Helper function to get percentage from kpiScores
//     const getPercentageFromKpiScores = (kpiScores, key) => {
//       if (!kpiScores || !kpiScores[key]) return 0;

//       if (key === 'mashaer_presence') {
//         return kpiScores[key].details?.days_present * 20 || 0;
//       }
//       return kpiScores[key].details?.percentage || 0;
//     };

//     // Render content based on loading state and data availability
//     const renderContent = () => {
//       if (selfEvaluationListIsLoading) {
//         // Return loading state
//         return (
//           <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
//             <div className="spinner-border text-primary" role="status">
//               <span className="sr-only">{t("loading")}</span>
//             </div>
//           </div>
//         );
//       } else if (!evaluationCards || evaluationCards.length === 0) {
//         // Return no data state
//         return (
//           <NoDataComponent
//             title={t("no_evaluation_data_found")}
//             subtitle={t("no_evaluation_data_available_for_selected_office")}
//           />
//         );
//       } else {
//         // Return evaluation cards
//         return (
//           <CardsContainer>
//             {evaluationCards.map((card, index) => (
//               <Card key={card.id}>
//                 <CardLeftContent>
//                   <CardHeader>
//                     <CardText> {t("name")} : {card.memberInfo.name}</CardText>
//                     <CardText> {t("role")} : {card.memberInfo.role}</CardText>
//                     <CardText> {t("office")} : {card.memberInfo.office}</CardText>
//                   </CardHeader>
//                   <CardStatsContainer>
//                     {Object.keys(card.kpi_scores || {}).filter(key => key !== 'total_score').map((key, index) => {
//                       const percentage = getPercentageFromKpiScores(card.kpi_scores, key);

//                       return (
//                         <CardStat key={key}>
//                           <ColoredCardCircle color={ringColors[index % ringColors.length]} />
//                           <StatItem>
//                             <StatLabel>{t(key)}:</StatLabel>
//                             <StatValue>{percentage.toFixed(1)}%</StatValue>
//                           </StatItem>
//                         </CardStat>
//                       );
//                     })}
//                     <CardStat>
//                       <ColoredCardCircle color="#fff" />
//                       <StatItem>
//                         <StatLabel>
//                           <span style={{ fontWeight: 'bold' }}>{t("total_score")}:</span>
//                         </StatLabel>
//                         <StatValue>{card.kpi_scores.total_score.toFixed(1)}%</StatValue>
//                       </StatItem>
//                     </CardStat>
//                   </CardStatsContainer>
//                 </CardLeftContent>
//                 <CardRightContent>
//                   <CircularProgress kpiScores={card.kpi_scores} />
//                 </CardRightContent>
//               </Card>
//             ))}
//           </CardsContainer>
//         );
//       }
//     };


//     const onMemberNameChange = e => {
//       if (!e) {
//         // remove employee id from the payload
//         setSelfEvaluationParams(prevParams => ({
//           ...prevParams,
//           employee_id: null,
//         }));
//       }
//       setSelectedMember(e);
//     };

//     useEffect(() => {
//       if (memberShortList && memberShortList.length > 0) {
//         const options = memberShortList.map(member => ({
//           label: member.name,
//           value: member.id,
//         }));
//         setMemberOptions(options);
//       }
//     }, [memberShortList]);

//     // Handle date range changes
//     const handleDateRangeChange = (dateRange) => {
//       if (dateRange && dateRange.startDate && dateRange.endDate) {
//         setSelfEvaluationParams(prevParams => ({
//           ...prevParams,
//           start_date: dateRange.startDate.format('YYYY-MM-DD'),
//           end_date: dateRange.endDate.format('YYYY-MM-DD'),
//         }));
//       }
//     };

//     return (
//       <div className="content">
//         <PageTitle>{t("self_evaluation")}</PageTitle>
//         <HeaderContainer columns="1fr auto">
//           <SelfEvaluationFilter
//             officesShortList={officesShortList}
//             getOfficesShortList={getOfficesShortList}
//             selectedOffice={selectedOffice}
//             selectOffice={selectOffice}
//             searchTerm={searchTerm}
//             onSearchTermChange={onSearchTermChange}
//             handleSearchByName={handleSearchByName}
//             handleClearSearch={handleClearSearch}
//             userCodeSearchTerm={userCodeSearchTerm}
//             onUserCodeSearchTermChange={onUserCodeSearchTermChange}
//             handleSearchByUserCode={handleSearchByUserCode}
//             handleClearUserCodeSearch={handleClearUserCodeSearch}
//             selectedRole={selectedRole}
//             onRoleChange={handleRoleChange}
//             isMemberNameLoading={memberShortListIsLoading}
//             memberOptions={memberOptions}
//             selectedMember={selectedMember}
//             onMemberNameChange={onMemberNameChange}
//             saveErrors={saveErrors}
//             onDateRangeChange={handleDateRangeChange}
//           />
//         </HeaderContainer>
//         {/* Cards layout with circular progress charts or no data message */}
//         <Container>
//           {renderContent()}
//         </Container>
//         {/* Pagination will go here */}
//       </div>
//     );
// };

// export default SelfEvaluation;
